import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/apy-calculator',
  component: () => import('../../routes/APYCalculator.svelte'),
  card: {
    id: 'apy-calculator',
    title: 'APY Calculator',
    description: 'Calculate the Annual Percentage Yield from a nominal interest rate and compounding frequency. Compare savings accounts, CDs, and investment returns accurately.',
    icon: 'trending_up',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/apy-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'APY Calculator – Annual Percentage Yield Calculator',
    description: 'Free APY calculator to calculate Annual Percentage Yield from a nominal interest rate and compounding frequency. Compare savings accounts, CDs, and investment returns accurately with our free calculator.',
  },
};

export default meta;
